export type DataSourceItem<T> = {
  item: T
  rowProps?: {
    errorHighlight?: boolean
  }
}
